export const buttonAdditionalStyles = {
  borderRadius: '100px'
};